import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
export class DatatableRowsExpanderModel extends CoreModel {
/**
 * CfIcon component for the main expanding icon. Optional.
 */
expandAllIcon?: IconModel;
/**
 * CfIcon component for the main collapsing icon. Optional.
 */
collapseAllIcon?: IconModel;
/**
 * @hidden 
 * It is the constructor for the Datatable component. It takes the values from component to create the Datatable object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableRowsExpanderModel_tsickle_Closure_declarations() {
/**
 * CfIcon component for the main expanding icon. Optional.
 * @type {?}
 */
DatatableRowsExpanderModel.prototype.expandAllIcon;
/**
 * CfIcon component for the main collapsing icon. Optional.
 * @type {?}
 */
DatatableRowsExpanderModel.prototype.collapseAllIcon;
}

